export const en = {
    'status-disconnected': 'Return to call',
    'status-active': 'Disconnect from call',
    'status-join': 'Join to call',
    'status-ended': 'Join to call',
    'reconnect-button': 'Return',
    'disconnect-button': 'Disconnect',
    'join-button': 'Join',
};
